var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinEWastePinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#D00404"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 15,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8569 10.3462L12.8569 19.6538C12.8569 20.1212 13.2087 20.5 13.6426 20.5L18.3569 20.5C18.7909 20.5 19.1426 20.1212 19.1426 19.6538L19.1426 10.3462C19.1426 9.87884 18.7909 9.5 18.3569 9.5L13.6426 9.5C13.2087 9.5 12.8569 9.87884 12.8569 10.3462Z",
    stroke: "black",
    fill: "white",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 18.1429C15.566 18.1429 15.2142 18.4947 15.2142 18.9286C15.2142 19.3626 15.566 19.7144 15.9999 19.7144C16.4339 19.7144 16.7856 19.3626 16.7856 18.9286C16.7856 18.4947 16.4339 18.1429 15.9999 18.1429Z",
    fill: "black",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinEWastePinRed);
export default __webpack_public_path__ + "static/media/trash-bin-eWaste-pin-red.9f6c10bdb8243bb5275e075cacb4ab47.svg";
export { ForwardRef as ReactComponent };